import React from 'react';

import CssBaseline from '@material-ui/core/CssBaseline';
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { useDispatch } from 'react-redux';
import ContentWrapper from 'components/contentWrapper/ContentWrapper';
import themes from 'consts/theme';
import UserSessionDataHandler from 'auth/UserSessionsDataHandler';
import { setFontSize } from 'store/actions/fontSize/setFontSize';
import ThemeTypeContext from './themeContext';

const Wrapper = () => {
  const dispatch = useDispatch();
  const [themeType, setThemeType] = React.useState(
    UserSessionDataHandler.getTheme() || 'light'
  );
  const [theme, setTheme] = React.useState(themes[themeType]);
  const contextValue = { themeType, setThemeType };

  React.useEffect(() => {
    setTheme(themes[themeType]);
  }, [themeType]);

  React.useEffect(() => {
    dispatch(setFontSize(UserSessionDataHandler.getFontSize()));
  }, []);

  return (
    <div>
      <ThemeTypeContext.Provider value={contextValue}>
        <MuiThemeProvider theme={createTheme(theme)}>
          <ContentWrapper />
          <CssBaseline />
        </MuiThemeProvider>
      </ThemeTypeContext.Provider>
    </div>
  );
};

export default Wrapper;
